/**
 * Dual-URL media pick: Cloudinary (or other primary) + ImageKit mirror.
 * When preferImageKit is true and a mirror exists, serve ImageKit first.
 */

export function isImageKitUrl(src) {
  return /ik\.imagekit\.io/i.test(String(src || ''));
}

export function isBlobUrl(src) {
  return /\.blob\.vercel-storage\.com/i.test(String(src || ''));
}

/**
 * @param {{ primary?: string, imagekit?: string, blob?: string, preferImageKit?: boolean }} opts
 */
export function pickMediaUrl({ primary = '', imagekit = '', blob = '', preferImageKit = false } = {}) {
  const p = String(primary || '').trim();
  const ik = String(imagekit || '').trim();
  const b = String(blob || '').trim();
  if (preferImageKit && ik) return ik;
  return p || ik || b || '';
}

/**
 * Failover candidates AFTER the chosen primary src fails to load.
 * @param {{ primary?: string, imagekit?: string, blob?: string, preferImageKit?: boolean, placeholder?: string }} opts
 */
export function mediaFailoverChain({
  primary = '',
  imagekit = '',
  blob = '',
  preferImageKit = false,
  placeholder = '',
} = {}) {
  const p = String(primary || '').trim();
  const ik = String(imagekit || '').trim();
  const b = String(blob || '').trim();
  const place = String(placeholder || '').trim();
  const chain = [];
  if (preferImageKit) {
    if (p) chain.push(p);
    if (b) chain.push(b);
  } else {
    if (ik) chain.push(ik);
    if (b) chain.push(b);
  }
  if (place) chain.push(place);
  return chain.filter(Boolean);
}

/**
 * Advance an <img> through a failover chain on error.
 */
export function applyMediaFailoverChain(imgEl, chain) {
  if (!imgEl || !Array.isArray(chain) || !chain.length) return false;
  let idx = Number(imgEl.dataset.failoverIndex || 0);
  while (idx < chain.length) {
    const next = chain[idx];
    idx += 1;
    imgEl.dataset.failoverIndex = String(idx);
    if (next && next !== imgEl.src && !imgEl.src.includes(String(next).split('?')[0])) {
      imgEl.src = next;
      return true;
    }
  }
  return false;
}
